import React from 'react';
import EnvConstant from '../../constants/EnvConstant';
import * as Session from '../../domain/Session';
import { Article as Styled } from '../../styles/about';
import SectionClip from './SectionClip';
import SectionRule from './SectionRule';
import SectionAttention from './SectionAttention';
import SectionPolicy from './SectionPolicy';

/**
 * ラウンジとは？
 */
interface Props {
  session: Session.Value;
}

const AboutComponent: React.FC<Props> = props => {
  const { session } = props;
  const titleImgSrc = session.isSp
    ? `${EnvConstant.API_COMMON_PANE_URL}/img/lounge/title_about_upper.png`
    : `${EnvConstant.API_COMMON_PANE_URL}/img/lounge/title_about.png`;

  return (
    <Styled>
      <h1>
        <img src={titleImgSrc} alt="ラウンジは、看護師、看護学生さんが集い、ほっとできる場所です。" />
        {session.isSp && (
          <img src={`${EnvConstant.API_COMMON_PANE_URL}/img/lounge/title_about_lower.png`} alt="ラウンジのご利用方法やルールをご説明します。" />
        )}
      </h1>
      <SectionClip isSp={session.isSp} isGuest={session.isGuest()} />
      <SectionRule isSp={session.isSp} />
      <SectionAttention />
      <SectionPolicy />
    </Styled>
  );
};

export default AboutComponent;
